import * as utils from "../utils";
import { STORAGE } from "../constants";

const localStorageLastLocationKey = STORAGE.PREFIX + STORAGE.LAST_LOCATION_KEY;

function acceptLocation(lastLocation) {
  return !!(
    lastLocation &&
    lastLocation.pathname &&
    lastLocation.pathname !== "/" &&
    lastLocation.pathname.indexOf("auth") === -1 &&
    lastLocation.pathname !== "/logout"
  );
}

export function saveLastLocation(lastLocation) {
  const localStorageLocations = utils.getStorage(localStorageLastLocationKey);
  const _useLocations = localStorageLocations
    ? JSON.parse(localStorageLocations)
    : [];

  if (acceptLocation(lastLocation)) {
    _useLocations.push(lastLocation.pathname);
    utils.setStorage(
      localStorageLastLocationKey,
      JSON.stringify(_useLocations),
      120
    );
  }
}

export function forgotLastLocation() {
  utils.removeStorage(localStorageLastLocationKey);
}

export function getLastLocation() {
  const localStorageLocations = utils.getStorage(localStorageLastLocationKey);
  if (!localStorageLocations) {
    return "/";
  }

  const _userLocations = JSON.parse(localStorageLocations);
  return _userLocations.length > 0 ? _userLocations.pop() : "/";
}
